import { compeonOfferUnitFormatters } from 'modules/Offers/InquiryOffersSection/CompeonOffers/withCompeonOffers/compeonOfferUnits/unitFormatters';
import { COMPEON_OFFER_PROPS } from 'modules/Offers/InquiryOffersSection/CompeonOffers/withCompeonOffers/getPropertiesForProduct';

const { percentPerYear } = compeonOfferUnitFormatters;

export const compeonOtherUnits = {
  [COMPEON_OFFER_PROPS.value]: percentPerYear,
};
